/* istanbul ignore file */

export const FORM_FIELDS = {
  HEADLINE: 'headline',
  STANDFIRST: 'standfirst',
  LANGUAGE: 'language',
  CONTENT_BODY: 'content_body',
  BODY: 'body',
  IMGS: 'imgs',
  VIDEOS: 'videos',
  WEBSITES: 'websites',
  INTERNAL_INFORMATION: 'internal_information',
  LIVE_URLS: 'live_urls',
  CONTENT_IDS: 'content_ids',
  ARTICLE_VERSION_LIST: 'article_version_list',
  NEXT_STATES: 'next_states',
};
